import {withRouter} from 'react-router-dom'
import {inject, observer} from 'mobx-react'
import Spinner from '../Spinner'
import React from 'react'
import styles from './style.css'

function KpiListItem ({kpi, selected, onClick}) {
    return <div className={selected ? styles.selectedItem : styles.item} onClick={onClick}>
        <span className={styles.name}>
            {kpi.rel}
        </span>
    </div>
}

function removePrefix(href) {
    return href.replace(/^\/v1/, '')
}

const KpiList = withRouter(inject('store', 'localizationStore')(observer(
  ({store, localizationStore, onAddAgent, history, location, container}) => {
    const KPIs = store.KPIs
    const mapFunction = (kpi, index) => {
        const link = removePrefix(kpi.href)
        return <KpiListItem key={index} kpi={kpi} selected={link === location.pathname + location.search} onClick={() => history.push(link)}/>
    }
    const emptyListFallback = store.KPIsFetching
      ? <Spinner />
      : <span>{localizationStore.locale.empty_kpi_list}</span>

    return React.createElement(container, {items: KPIs, mapFunction, emptyListFallback})
  })));

export default KpiList;


// WEBPACK FOOTER //
// ./src/components/KpiList/index.js